<template>
  <v-dialog max-width="500" :model-value="isVisible" persistent>
    <v-card :title="`Edit (${customer?.payerUser?.email || customer?.payerUserEmail})`">
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-text-field
            name="company"
            label="Company"
            type="text"
            autocomplete="none"
            validate-on="blur"
            :maxLength="254"
            v-model="company"
            :rules="[rules.required]"
            variant="outlined"
            density="default"
          >
          </v-text-field>

          <v-text-field
            name="startDate"
            label="Start Date"
            type="date"
            autocomplete="none"
            validate-on="blur"
            v-model="startDate"
            :rules="[rules.required]"
            variant="outlined"
            density="default"
          ></v-text-field>

          <v-text-field
            name="expirationDate"
            label="Expiration Date"
            type="date"
            autocomplete="none"
            validate-on="blur"
            v-model="expirationDate"
            :rules="[rules.required]"
            variant="outlined"
            density="default"
          ></v-text-field>

          <v-text-field
            name="quantity"
            label="Quantity"
            type="number"
            autocomplete="none"
            validate-on="blur"
            v-model="quantity"
            :rules="[rules.required]"
            variant="outlined"
            density="default"
          >
          </v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn rounded="lg" size="large" variant="outlined" color="gray" @click="cancel" :disabled="isLoading">
          Cancel
        </v-btn>
        <v-btn rounded="lg" size="large" color="primary" variant="flat" @click="save" :loading="isLoading">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import format from 'date-fns/format'

export default {
  name: 'UnsavedCommentsDialog',
  props: {
    customer: {
      type: Object,
      required: true
    },
    isVisible: {
      type: Boolean,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: false
    }
  },
  emits: ['save', 'cancel'],
  data () {
    return {
      valid: true,
      company: '',
      quantity: '',
      payerUserEmail: null,
      startDate: null,
      expirationDate: null,
      rules: {
        required: (value) => !!value || 'Required.'
      }
    }
  },
  methods: {
    save () {
      this.$emit('save', {
        id: this.customer.id,
        company: this.company,
        quantity: this.quantity,
        startDate: new Date(this.startDate).toISOString(),
        expirationDate: new Date(this.expirationDate).toISOString()
      })
    },
    cancel () {
      this.$emit('cancel')
    }
  },
  watch: {
    customer: function (customer) {
      if (customer) {
        this.company = customer.company
        this.quantity = customer.quantity
        this.startDate = format(new Date(customer.startDate), 'yyyy-MM-dd')
        this.expirationDate = format(new Date(customer.expirationDate), 'yyyy-MM-dd')
      } else {
        this.$refs.form.reset()
      }
    }
  }
}
</script>
